export default __webpack_public_path__ + "static/media/add_external_link.9c5a2c2d.svg";